export const COOKIE_NAME = "ecosystm360-awards-form";
export const COOKIE_VALUE = "ecosystm360-awards-form-2021";
export const API_BASE_URL = "https://amz-api.ecosystm360.com/dev";
export const SUBMIT_AWARDS_FORM_URL = "awards/submit";
export const SEND_EMAIL_NOTIFICATION_API_URL = " https://v9yzaitkqg.execute-api.ap-southeast-1.amazonaws.com/dev/sendEmail"
